import { useFieldValue } from "components/form/input/NestedField";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";
import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import { useEffect, useMemo } from "react";
import FormRow from "components/form/FormRow";
import Torr from "..";
import SelectInput from "components/form/input/SelectInput";
import { useForm } from "react-final-form";
import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import Operador from "entity/Operador";

export default function TorrEditFields({ visita, TipoClass }) {
    const [tipo, setTipo] = useTipoApontamento();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const params = useMemo(() => visita.cliente.getParams(Torr, "Mecanizado", TipoClass), [visita.cliente]);

    const [apontamento] = useFieldValue();
    const form = useForm();

    useEffect(() => {
        if (tipo !== "Mecanizado") {
            setTipo("Mecanizado");
        }
    }, [setTipo, tipo]);

    useEffect(() => {
        if (apontamento) {
            const conformidade = Torr.calcConformidade(apontamento, params);
            apontamento.conformidade = conformidade;
            form.change("conformidade", conformidade);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, params]);

    return (
        <>
            <ApontamentoCommonFields visita={visita} />

            <ApontamentoAmostraParams tipoFixedValue="Mecanizado">
                <FormRow>
                    <SelectInput name="turno" label="Turno" options={["A", "B", "C"]} required />
                </FormRow>

                <FormRow>
                    <EntitySearchInput
                        name="operador"
                        label="Operador"
                        EntityClass={Operador}
                        extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)}
                    />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="Meta (%):">{params.meta}</ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoColetas visita={visita}>
                <SelectInput name="torroes" label="Presença de Torrões" options={["Sim", "Não"]} required />
            </ApontamentoColetas>

            <ApontamentoResultado conformidadeLabel="Torrões (%)" />

            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
